import * as a from '@mitranim/js/all.mjs'

// Warning: this must be '/', not '', because the latter may be interpreted as
// "current pathname" by some code.
export const LINK_HOME                         = `/`
export const LINK_PLANS                        = `/plans`

export const LINK_FOR_USERS                    = `/landings/for-users`
export const LINK_FOR_PRACTITIONERS            = `/landings/for-practitioners`
export const LINK_FOR_DOCTORS                  = `/landings/for-doctors`
export const LINK_FOR_ORGANIZATIONS            = `/landings/for-organizations`

export const LINK_PRACTITIONER_REGISTER        = `/practitioners/register`
export const LINK_ORGANIZATION_REGISTER        = `/organizations/register`
export const LINK_USER_UPGRADE                 = `/user/upgrade`
export const LINK_USER_UPGRADE_TO_PRACTITIONER = `/user/upgrade?mode=practitioner`
export const LINK_USER_UPGRADE_TO_ORGANIZATION = `/user/upgrade?mode=organization`
export const LINK_LOGIN                        = `/auth/login`
export const LINK_LOGIN_PRACTITIONER           = a.url(LINK_LOGIN).setQuery({redir: LINK_USER_UPGRADE_TO_PRACTITIONER}).href
export const LINK_LOGIN_ORGANIZATION           = a.url(LINK_LOGIN).setQuery({redir: LINK_USER_UPGRADE_TO_ORGANIZATION}).href
export const LINK_MY_ARTICLES                  = `/my-articles`
export const LINK_MY_ARTICLES_NEW              = `/my-articles/new`
export const LINK_MY_BOOKS                     = `/my-books`
export const LINK_MY_BOOKS_CREATE              = `/my-books/create`
export const LINK_MY_EVENTS                    = `/my-events`
export const LINK_MY_EVENTS_CREATE             = `/my-events/create`
export const LINK_MY_FAVORITES                 = `/my-favorites`
export const LINK_MY_INSTALL_MOBILE_APP        = `/my-install-mobile-app`
export const LINK_MY_NETWORKS                  = `/my-networks`
export const LINK_MY_PREFERENCES               = `/my-preferences`
export const LINK_MY_PROFILE                   = `/my-profile`
export const LINK_MY_PROFILE_MODERATION        = `/my-moderation`
export const LINK_MY_PROFILE_REPLIES           = `/my-replies`
export const LINK_MY_PROMOTIONS                = `/my-promotions`
export const LINK_MY_PROMOTION_SERVICE_PPC     = `/my-promotions/service_ppc`
export const LINK_MY_PROMOTION_ARTICLE_LINK    = `/my-promotions/article_link`
export const LINK_MY_REFERRAL                  = `/my-referral`
export const LINK_MY_GIFT_CARDS                = `/my-gift-cards`
export const LINK_MY_PAYMENT_METHODS           = `/my-payment-methods`
export const LINK_MY_PURCHASES                 = `/my-purchases`
export const LINK_MY_PURCHASES_GIFT_CARDS      = `/my-purchases/gift-cards`
export const LINK_MY_PURCHASES_PRODUCTS        = `/my-purchases/products`
export const LINK_MY_PURCHASES_SERVICES        = `/my-purchases/services`
export const LINK_MY_PURCHASES_EVENTS          = `/my-purchases/events`
export const LINK_MY_PURCHASES_VIDEOS          = `/my-purchases/videos`
export const LINK_MY_PURCHASES_COURSES         = `/my-purchases/courses`
export const LINK_MY_FIN_TRANSFERS             = `/my-fin-transfers`
export const LINK_MY_SALES                     = `/my-sales`
export const LINK_MY_SALES_CONNECT_SERVICES    = `/my-sales/connect-payment-services`
export const LINK_MY_SALES_WITHDRAWAL          = `/my-sales/withdrawal`
export const LINK_MY_SERVICES                  = `/my-services`
export const LINK_MY_SERVICES_CREATE           = `/my-services/create`
export const LINK_MY_VIDEOS                    = `/my-videos`
export const LINK_MY_VIDEOS_CREATE             = `/my-videos/create`
export const LINK_MY_COURSES                   = `/my-courses`
export const LINK_MY_COURSES_CREATE            = `/my-courses/create`
export const LINK_MY_COURSE_SECTIONS           = `/my-course-sections`
export const LINK_WRITE_AN_ARTICLE             = LINK_MY_ARTICLES_NEW
export const LINK_MY_PURCHASES_SERVICES_REVIEWS= a.urlJoin(LINK_MY_PURCHASES_SERVICES, `review/cal_abs_timespans`)
export const LINK_MY_SERVICES_BOOKINGS_REVIEWS = `/my-services/bookings/review/cal_abs_timespans`
export const LINK_MY_WITH_PREOPENED_POPUP      = (slug, interval) => a.url(LINK_MY_PROMOTIONS).setQuery({slug, interval})
export const LINK_MY_ORGANIZATIONS             = `/my-organizations`
export const LINK_MY_MESSAGES                  = `/my-messages`
export const LINK_MY_REVIEWS                   = `/my-reviews`
export const LINK_MY_PRODUCTS                  = `/my-products`
export const LINK_MY_STATISTICS                = `/my-statistics`
export const LINK_MY_CALENDAR                  = `/my-calendar`
export const LINK_MY_AVAILABILITY              = `/my-calendar/availability`
export const LINK_MY_AI_ASSISTANT              = `/my-ai-assistant`

export const LINK_PRACTITIONERS                = `/practitioners/list`
export const LINK_PRACTITIONERS_MAP            = `/practitioners/map`
export const LINK_LUMINARIES                   = `/luminaries`
export const LINK_ORGANIZATIONS                = `/organizations`
export const LINK_MSGS                         = `/msgs`
export const LINK_MSGS_MY                      = LINK_MSGS + `/my`
export const LINK_MSGS_FOLLOWING               = LINK_MSGS + `/following`
export const LINK_MSGS_REPLIES                 = LINK_MSGS + `/replies`
export const LINK_MSGS_MENTIONS                = LINK_MSGS + `/mentions`
export const LINK_MSGS_PERSONAL                = LINK_MSGS + `/pm`
export const LINK_MSGS_PM                      = (pk) => a.urlJoin(LINK_MSGS_PERSONAL, pk)
export const LINK_MSGS_MODERATIONS             = LINK_MSGS + `/moderations`
export const LINK_SERVICES                     = `/services`
export const LINK_EVENTS                       = `/events`
export const LINK_COURSES                      = `/courses`
export const LINK_ARTICLES                     = `/articles`
export const LINK_VIDEOS                       = `/videos`
export const LINK_BOOKS                        = `/books`
export const LINK_PRODUCTS                     = `/products`
export const LINK_ABOUT_US                     = `/about-us`
export const LINK_TERMS_OF_SERVICE             = `/terms-of-service`
export const LINK_PRIVACY_POLICY               = `/privacy-policy`
export const LINK_FAQ                          = `/faq`
export const LINK_OUR_MISSION                  = `/our-mission`
export const LINK_REFER_A_PRACTITIONER         = `/refer-a-practitioner`
export const LINK_GIFT_CARDS                   = `/gift-cards`
export const LINK_GIFT_CARDS_TERMS             = `/gift-cards/terms`
export const LINK_SUBSCRIPTION                 = `/subscription`
export const LINK_CONTACT_US                   = `/contact-us`
export const LINK_DONATIONS                    = `/donations`
export const LINK_ADVERTISERS                  = `/advertisers`
export const LINK_REFERRAL                     = `/referral`
export const LINK_REFERRAL_TERMS               = `/referral/terms`
export const LINK_PAYMENT_SUCCESS              = `/payment-success`
export const LINK_THANK_YOU                    = `/thank-you`
export const LINK_EMBED_BUY_MEMBERSHIP         = `/embed/buy-membership`
export const LINK_FLASH                        = `/flash`

export const LINK_SEARCH                       = `/search`
export const LINK_SEARCH_SERVICES              = `/search/services`
export const LINK_SEARCH_EVENTS                = `/search/events`
export const LINK_SEARCH_VIDEOS                = `/search/videos`
export const LINK_SEARCH_BOOKS                 = `/search/books`
export const LINK_SEARCH_ARTICLES              = `/search/articles`
export const LINK_SEARCH_PRACTITIONERS         = `/search/practitioners`
export const LINK_SEARCH_ORGANIZATIONS         = `/search/organizations`

export const LINK_LP_SALES                     = `/landings/sales`
export const LINK_LP_ENERGY                    = `/landings/energy`
export const LINK_LP_STRESS                    = `/landings/stress`
export const LINK_LP_ANXIETY                   = `/landings/anxiety`
export const LINK_LP_NUTRITIONAL_THERAPY       = `/landings/nutritional-therapy`
export const LINK_LP_REIKI                     = `/landings/reiki`
export const LINK_LP_DISTANT_HEALING           = `/landings/distant-healing`
export const LINK_LP_PSYCHOLOGIST              = `/landings/psychologist`
export const LINK_LP_COACHING                  = `/landings/coaching`
export const LINK_LP_FORTUNETELLING            = `/landings/fortunetelling`
export const LINK_LP_ENERGY_HEALING            = `/landings/energy-healing`